import {Injectable} from '@angular/core';

import {LoginInfo} from '../models'
import {LoginInfoProvider} from '../ev-dal/login-info.provider';

// todo: deprecate
/**
 * @deprecated
 */
@Injectable({
  providedIn: 'root'
})
export class CommonAuthenticationService {

  constructor(private _loginInfoProvider: LoginInfoProvider) {
  }


  clearLoginInfo() {
    this._loginInfoProvider.clearLoginInfo();
  }

  getToken() {
    return this._loginInfoProvider.token;
  }

  getLoginData(): Partial<LoginInfo> {
    return this._loginInfoProvider.loginInfo;
  }

  getModule() {
    return this._loginInfoProvider.module;
  }

  getPartnerDetailData() {
    return this._loginInfoProvider.parnerDetailData;
  }

  getPartnerId() {
    return this._loginInfoProvider.partnerId;
  }

  getProfileId() {
    return this._loginInfoProvider.profileId;
  }

  getRoleName() {
    return this._loginInfoProvider.roleName;
  }

  getUserFullName() {
    return this._loginInfoProvider.userFullName;
  }

  getUserId() {
    return this._loginInfoProvider.userId;
  }

  isSenior(): boolean {
    return this._loginInfoProvider.isSenior;
  }

  setLoginData(loginData: Partial<LoginInfo>) {
    return this._loginInfoProvider.loginInfo = loginData;
  }

  setPartnerDetailData(data) {
    return this._loginInfoProvider.partnerDetailData = data;
  }
}
